import {DoctorDataModel} from '../../../models/doctors/doctor-data.model';
import {DataAppointmentModel} from '../../../models/appointments/data-appointment.model';
import {PatientCaseViewDataModel} from '../../../models/patient/patient-case-view-data.model';
import {CaseProcedureConfigurationModel} from '../../../models/caseProcedures/case-procedure-configuration.model';
import {OperatoryDataModel} from '../../../models/clients/operatory-data.model';
import {TdoUserConfigurationModel} from '../../../models/configuration/user/tdo-user-configuration.model';
import {AppointmentDataModel} from "../../scheduler/models/appoitment-model";

export class AppointmentDialogDataModel {
  allDoctors: DoctorDataModel[] = [];
  appointment: DataAppointmentModel;
  procedures: CaseProcedureConfigurationModel[] = [];
  patientCases: PatientCaseViewDataModel[] = [];
  operatories: OperatoryDataModel[] = [];
  users: TdoUserConfigurationModel[];

  currentLocationId: string;
  timeIncrement: number;
  cancellingAppointment: boolean = false;
  confirmingAppointment: boolean = false;
  isReadOnly: boolean = false;
}
//
// export class AppointmentDialogDataV2Model {
//   allDoctors: DoctorDataModel[] = [];
//   appointment: AppointmentDataModel;
//   //procedures: CaseProcedureConfigurationModel[] = [];
//   operatories: OperatoryDataModel[] = [];
//
//   currentLocationId: string;
//   timeIncrement: number;
//   cancellingAppointment: boolean = false;
//   confirmingAppointment: boolean = false;
//   isReadOnly: boolean = false;
// }
